export const setRowNumber = (items) => {
    let index = 0;
    return items?.map((item) => {
        index += 1;
        return {
            ...item,
            row_number: index
        };
    });
};


export const replaceAlbanianChars = (str) => {
    return str.toString().toLowerCase().replace(/ë/g, "e").replace(/ç/g, "c");
};


export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};


export const filterDataByName = (items, value) => {
    let filteredData = [];
    const searchValue = value.toString().replace(/\s+/g, '').trim();

    if (value !== "") {
        filteredData = items.filter((entry) => replaceAlbanianChars(entry.name).startsWith(replaceAlbanianChars(searchValue)));
        filteredData = setRowNumber(filteredData);
    } else {
        filteredData = items;
    }

    return filteredData;
};


export const filterDataBySurname = (items, value) => {
    let filteredData = [];
    const searchValue = value.toString().replace(/\s+/g, '').trim();

    if (value !== "") {
        filteredData = items.filter((entry) => replaceAlbanianChars(entry.surname).startsWith(replaceAlbanianChars(searchValue)));
        filteredData = setRowNumber(filteredData);
    } else {
        filteredData = items;
    }

    return filteredData;
};